import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const startLoading = useCallback(() => {
    setLoading(true);
    setError(null);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);

  const setErrorState = useCallback((error) => {
    setError(error);
    setLoading(false);
  }, []);

  const withLoading = useCallback(async (fn) => {
    try {
      startLoading();
      const result = await fn();
      return result;
    } catch (error) {
      setErrorState(error);
      throw error;
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading, setErrorState]);

  return (
    <LoadingContext.Provider
      value={{
        loading,
        error,
        startLoading,
        stopLoading,
        setError: setErrorState,
        withLoading
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading deve ser usado dentro de um LoadingProvider');
  }
  return context;
}; 